"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = vue_1.default.extend({
    name: 'PopupPanel',
    methods: {
        onclick() {
            this.$emit('close');
        },
        keylistener(event) {
            if (event.key === 'Escape') {
                this.onclick();
                return;
            }
        },
    },
    computed: {},
    destroyed() {
        window.removeEventListener('keydown', this.keylistener);
    },
    mounted() {
        window.addEventListener('keydown', this.keylistener);
    },
});
